import { useCriticalAlertsOnboarding } from 'hooks/useCriticalAlertsOnboarding';
import type { OnboardingProgress } from 'components/OnboardingLayout';

export type OnboardingStep =
  | 'permissions'
  | 'critical_alerts'
  | 'notifications';

/**
 * Step counts for the brand-refresh onboarding progress bar.
 *
 * Total is 3 on iOS+CA, 2 elsewhere. We don't update the total when CA gets
 * skipped, so the bar always advances forward and a skipped step shows up as
 * a larger jump.
 */
export const useOnboardingProgress = (
  step: OnboardingStep,
): OnboardingProgress => {
  const { isCriticalAlertsAvailable } = useCriticalAlertsOnboarding();

  const totalSteps = isCriticalAlertsAvailable ? 3 : 2;

  const currentByStep: Record<OnboardingStep, number> = {
    permissions: 1,
    critical_alerts: 2,
    notifications: totalSteps,
  };

  return { current: currentByStep[step], total: totalSteps };
};
